import React, {useState, useEffect} from "react";
import { getDatabase, ref, set } from "firebase/database";
import firebase from './database/firebase';
import { StyleSheet, Text, View, Button, TextInput, Dimensions,CheckBox, Linking,ActivityIndicator } from "react-native";
import { RadioButton } from 'react-native-paper';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const user_id = urlParams.get('uid');


function writeUserData(userId,paragraph, time, transpost,prompt) {
	firebase.database().ref('translatedPosts_edit_high/' + userId+'_'+time).set({
        time: time,
        post: paragraph,
        translatedpost:transpost,
        userId: userId,
        prompt:prompt,
        sensitivity:'high',
	});
  }
  function writeUserDataFinal(userId,paragraph, time, transpost,including,prompt) {
    firebase.database().ref('finalTranslatedPosts_edit_high/' + userId+'_'+time).set({
          time: time,
          sensitivity:'high',
          prompt:prompt,
          post: paragraph,
          translatedpost:transpost,
          transInclude:including,
          userId: userId,
    });
    }
const Translate2 = (props) => {

    const [isSelected, setSelection] = useState('yes');
    const [post, setPost] = useState(props.navigation.state.params.originalpost);
    const [translation, setTranslation] = useState("");
    const [loading, setLoading] = useState(false);
    const getTransData = async (user_id) => { 
      const dbRef = firebase.database().ref();
        dbRef.child("trans_posts_edit_high/").child(user_id).get().then((snapshot) => {
          if (snapshot.exists()) {
          // alert("Gowa el function: "+snapshot.child("translatedpost").val());
           setTranslation(snapshot.child("translatedpost").val());
          
            //setTranslation(snapshot.val().translatedpost);
            return  snapshot.child("translatedpost").val();
          } else {
            setTranslation("");
         
            //alert("No data available");
            return "";
          }
        }).catch((error) => {
          console.error(error);
        });
        
        }
    useEffect(() => {
      getTransData(user_id);
     // alert(translation);
    }, []);
    if(loading===true)
    {
      return(
        <View style={styles.preloader}>
          <ActivityIndicator size="large" color="#0000ff"/>
        </View>
      )
    }
    else{

      return(
        <div>   
			<View style={styles.container}>
				<Text style={styles.text}>Your original Post</Text>
				  <View style={styles.textAreaContainer} >
                
					<TextInput
					style={styles.textArea1}
				
					placeholder={props.navigation.state.params.originalpost}
					placeholderTextColor={'#DCDCDC'}
          editable={false}
					numberOfLines={40}
					multiline={true}
					onChangeText={post => setPost(post)}
          value={post}/>
                  
				</View>
        <Text style={styles.label}>The following English translation can be shown to readers who do not understand {props.navigation.state.params.language},<Text style={styles.label,{color:'#F44336'}}> please edit this translation as you see fit</Text></Text>
                 <View style={styles.textAreaContainer}>
                <TextInput
                style={styles.textArea2}
                editable={isSelected}
                //placeholder={location.state.translatedpost}
                placeholderTextColor="black"
                numberOfLines={40}
                multiline={true}
                onChangeText={translation => {setTranslation(translation)
                  writeUserData(user_id,props.navigation.state.params.originalpost,new Date().toString(),translation,props.navigation.state.params.secondtopic)}}
                value={translation}/>
              
            </View>
            <View style={styles.checkboxContainer}>
            <RadioButton.Group onValueChange={newValue => {setSelection(newValue);
            }} value={isSelected}>
      <View style={styles.radioContainer}>
        
        <RadioButton value='yes' />
		
		<Text style={styles.label}>I want to include the translation.</Text>
		  </View>
      <View style={styles.radioContainer}>
        
        <RadioButton value='no' />
		<View style={styles.radioContainer2}>
		<Text style={styles.label}>I don't want to include the translation.</Text>
		</View>
      </View>
    </RadioButton.Group>
    
      </View>
				<View style={styles.buttonContainer}>

                <Button 
                    color='#341ada'
                    title="Back"
                    style={StyleSheet.buttonStyle}
                    onPress={() => { props.navigation.navigate('Main2', {detail: post, language: props.navigation.state.params.language,uid:user_id}); }}> 
                </Button>
                
                <Button 
                    color='#341ada'
                    title="Next"
                    style={StyleSheet.buttonStyle}
                    onPress={() => {
                writeUserDataFinal(user_id,props.navigation.state.params.originalpost,new Date().toString(),translation,isSelected,props.navigation.state.params.secondtopic)
                if(isSelected ==='yes')       
                {props.navigation.navigate('Tfinal2', {detail: post,posting:isSelected,translated:translation,language: props.navigation.state.params.language,uid:user_id});}
                else
                {props.navigation.navigate('Final2', {detail: post,posting:isSelected,translated:translation,language: props.navigation.state.params.language,uid:user_id});}
                     }}> 
                </Button>
				

				</View>
                
			</View>
        </div>
    )
    }
}
const styles = StyleSheet.create({
	container: {
		padding: 20,
		flex: 1,
		display: "flex",
		marginTop: 1,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
	},
	buttonContainer:{
		width: '19%',
		alignSelf: 'center',
		marginVertical: 12,
        marginHorizontal: 30,
        flex:1,
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center'
	},

	text: {
		fontWeight: "bold",
		fontSize: 20
	},
	buttonStyle: {
		alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 12,
	paddingHorizontal: 32,
	borderRadius: 0,
	elevation: 13,
	backgroundColor:"#341ada"
	},
    
	listContainer: {
        flexDirection: "column",
		paddingTop: 12
	},
	listItem: {
		fontSize: 20
	},
    checkboxContainer: {
        flexDirection: "row",
        justifyContent: "center",
        marginBottom: 2,
      },
      checkbox: {
        alignSelf: "center",
      },
      label: {
        //margin: 8,
        fontWeight: "bold",
        fontSize: 20,
      },
	textAreaContainer: {
		
		paddingTop: 12,
    paddingRight:Dimensions.get('window').width/15,
		paddingLeft: Dimensions.get('window').width/15,
		paddingBottom: 1,

	  },
	  textArea1: {
    backgroundColor:'#D3D3D3',
		height: 260,
		fontSize: 19,
		borderColor: '#000000',
		borderWidth: 1,
		justifyContent: "flex-start"
	  },
    textArea2: {
      height: 260,
      fontSize: 19,
      borderColor: '#341ada',
      borderWidth: 3,
      justifyContent: "flex-start"
      },
      preloader:{
        flex: 1,
        justifyContent: "center",
      },
	  radioContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
	},radioContainer2: {
	//	padding: 1,
		//marginTop: 8,
		textAlign: 'center',
        flexDirection: "column",
	},
})
export default Translate2